// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 828) return "static/chunks/828-dcaed778edc0664c.js";
	if (chunkId === 484) return "static/chunks/484-c3aaa499d97a27c1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"83edc8afc0370428","788":"aaecd056a500416a","826":"affe0987fe6a1a7e"}[chunkId] + ".js";
};